import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded"
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded"
import {Grid, Paper, Stack} from "@mui/material"
import ButtonWithIcon from "../Button/Button"
import DatePickerSelectV2 from "../Date/date-picker-select"
import TextFieldInput from "../Input/text-field-input"
import SelectComponent from "../select/select-component"
import {
    CONTRACT_VERSION_OPTIONS,
    WORKFLOW_STATUS_OPTIONS,
} from "./workflow-execution"

const EMPTY_FILTERS = {
    dagId: "",
    status: "",
    contractVersion: "",
    periodStart: "",
    periodEnd: "",
}

const WorkflowExecutionFilters = ({value, loading, onApply}) => {
    const [draft, setDraft] = useState({...EMPTY_FILTERS, ...value})

    useEffect(() => setDraft({...EMPTY_FILTERS, ...value}), [value])

    const setField = (field, fieldValue) =>
        setDraft((current) => ({...current, [field]: fieldValue}))

    const changeDate = (field) => (date) => {
        setField(field, date && dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "")
    }

    const clear = () => {
        setDraft(EMPTY_FILTERS)
        onApply(EMPTY_FILTERS)
    }

    return (
        <Paper sx={{p: 2, backgroundColor: "background.paper"}}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={3}>
                    <TextFieldInput
                        label="Workflow / DAG"
                        value={draft.dagId}
                        onChange={(event) => setField("dagId", event.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <SelectComponent
                        label="Status"
                        value={draft.status}
                        onChange={(event) => setField("status", event.target.value)}
                        options={WORKFLOW_STATUS_OPTIONS}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <SelectComponent
                        label="Contrato"
                        value={draft.contractVersion}
                        onChange={(event) => setField("contractVersion", event.target.value)}
                        options={CONTRACT_VERSION_OPTIONS}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <DatePickerSelectV2
                        label="Período inicial"
                        value={draft.periodStart || null}
                        defaultToToday={false}
                        onChange={changeDate("periodStart")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <DatePickerSelectV2
                        label="Período final"
                        value={draft.periodEnd || null}
                        defaultToToday={false}
                        onChange={changeDate("periodEnd")}
                    />
                </Grid>
                <Grid item xs={12} md={1}>
                    <Stack direction={{xs: "row", md: "column"}} spacing={1}>
                        <ButtonWithIcon
                            aria-label="Aplicar filtros"
                            icon={<FilterAltRoundedIcon/>}
                            disabled={loading}
                            onClick={() => onApply(draft)}
                        />
                        <ButtonWithIcon
                            aria-label="Limpar filtros"
                            icon={<RestartAltRoundedIcon/>}
                            disabled={loading}
                            onClick={clear}
                        />
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    )
}

WorkflowExecutionFilters.propTypes = {
    value: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onApply: PropTypes.func.isRequired,
}

export default WorkflowExecutionFilters
